module.exports = __webpack_public_path__ + "img/symbol_3.82b108d3.png";